var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{attrs:{"cols":"12","sm":"3"}},[_c('client-details',{attrs:{"client":_vm.client}}),_c('v-spacer',{staticClass:"my-5"}),(_vm.school)?_c('school-details',{attrs:{"school":_vm.school,"subSchool":_vm.subSchool}}):_vm._e()],1),_c('v-col',{attrs:{"cols":"12","sm":"9"}},[_c('evaluation-steps',{attrs:{"noEdit":_vm.noEdit}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }